import React, { useCallback, useEffect, useState } from 'react';
import { Flex, ListBox, Item, View, ProgressCircle} from '@adobe/react-spectrum';
import { CircleFill, ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import styles from './item_type_filter_component.module.css';
import { usePreloadAssets } from '../../../../hooks/UsePreloadAssets';
import { useViewInfo } from '../../../../hooks/UseViewInfo';
import { truncateText } from '../../../../utils/helperUtil';
import { useDependency } from '../../../../contexts/DependencyProvider';
import { ListItemTypeRequest } from '../../../../services/soap/item/requests/ListItemTypeRequest';

interface ItemTypeFilterComponentProps {
  createParams: (filterType: any, filterValue: any) => void;
  filterParams?: any;
  clearFilters?:boolean
}

const ItemTypeFilterComponent: React.FC<ItemTypeFilterComponentProps> = ({ createParams, filterParams,clearFilters }) => {
  const { isMobile } = useViewInfo();
  const { t } = useTranslation('products');
  const _t = (key: string) => t(`product_filters.${key}`, { ns: 'products' });
  const {industries} = usePreloadAssets();
  const {store,itemService} = useDependency();
  const [toggleListVisibility, setToggleListVisibility] = useState<any>({ stateList: true });
  const [selectedItemTypeKey, setSelectedItemTypeKey] = useState<Set<string>>(new Set(['All types']));
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [itemStatusList, setItemStatusList] = useState<any[]>([]);
  
  const handleSelectionChange = (value: any) => {
    const arrValue = Array.from(value);
    const filteredValue = arrValue.filter(item => item !== 'All types');
    const updateValue = filteredValue.length > 0 ? new Set(filteredValue) : new Set(['All types']);
    setSelectedItemTypeKey(new Set(Array.from(updateValue).map(String)));
    createParams('type', updateValue)
  };

  const getItemTypes = async () => {
    setShowLoader(true);
    const request = await itemService.listItemType(new ListItemTypeRequest(store.Server, store.SessionId));
    if(request.result === "OK"){
      setItemStatusList(request.ITEM_TYPE || []);
      setShowLoader(false);
    }
  }

  useEffect(() => {
    getItemTypes();
  }, []);

  useEffect(() => {
    if(clearFilters){
      setSelectedItemTypeKey(new Set(['All types']));
    }
  }, [clearFilters]);

  if (showLoader) {
    return (
      <Flex width="100%" height="100%" UNSAFE_style={{ backgroundColor: 'white' }} justifyContent={'center'} alignContent={'center'} alignItems={'center'}>
        <ProgressCircle aria-label="Loading…" isIndeterminate />
      </Flex>
    );
  } else {
    return (
      <Flex direction={'column'} minWidth={'200px'} marginTop={'10px'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'}>
        <Flex direction={'column'} gap={'4px'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} UNSAFE_className={styles.ItemStatus_container}>
          <Flex direction={'row'} height={'36px'} alignSelf={'stretch'} alignItems={'center'} justifyContent={'space-between'} UNSAFE_className={styles.industry_heading}>
            <Flex direction={'row'} flex={1} alignItems={'center'} justifyContent={'start'}>
              <View position={'relative'} UNSAFE_className={styles.industry_heading_text}>
                {_t('search_by_types')}
              </View>
            </Flex>

            {toggleListVisibility.stateList ? (
              <ChevronDown color="#B0BEC5" onClick={() => setToggleListVisibility((preValue: any) => ({ ...preValue, stateList: false }))} style={{ cursor: 'pointer' }} />
            ) : (
              <ChevronUp color="#B0BEC5" onClick={() => setToggleListVisibility((preValue: any) => ({ ...preValue, stateList: true }))} style={{ cursor: 'pointer' }} />
            )}
          </Flex>
          <Flex
            direction={'column'}
            alignSelf={'stretch'}
            alignItems={'start'}
            justifyContent={'start'}
            UNSAFE_className={isMobile ? styles.industry_component_mobile : styles.industry_component}
            UNSAFE_style={{ display: toggleListVisibility.stateList ? '' : 'none' }}
          >
            <ListBox
              id="listActivityStatus"
              width="100%"
              selectionMode="single"
              selectedKeys={selectedItemTypeKey}
              items={itemStatusList}
              onSelectionChange={(value: any) => {
                handleSelectionChange(value);
              }}
              UNSAFE_style={{ color: '#455a64 !important' }}
              aria-label="none"
            >
              {(item: any) => (
                <Item key={item.id} textValue={truncateText(item.name, 18)}>
                  <Flex direction={'row'} height={'30px'} UNSAFE_style={{ paddingBottom: '30px',paddingLeft:'10px' }}>
                    <View UNSAFE_style={{ whiteSpace: 'nowrap', color: '#455a64 !important', lineHeight: '30px' }}>
                      <span title={item.name}>{truncateText(item.name, 18)}</span>
                    </View>
                  </Flex>
                </Item>
              )}
            </ListBox>
          </Flex>
        </Flex>
      </Flex>
    );
  }
};

export default ItemTypeFilterComponent;
